<template>
  <div class="sel__filter" :class="$attrs.class" ref="sel__filter">
      <div class="form-label">{{ __(label) }}</div>
      <div v-if="!editItem" class="text-sm flex gap-3 items-center">
        <span v-if="itemValue" class="font-semibold">{{ itemValue }}</span>
        <span v-else class="italic font-light text-gray-400">Belum diisi</span>
        <icon v-if="editable" name="edit" @click="editItem=!editItem" class="w-4 h-4 mr-1 cursor-pointer" />
      </div>
      <div class="w-25 flex items-center">
          <input
              v-if="editItem"
              :id="id"
              ref="input"
              class="form-select w-25"
              :class="{ error: error }"
              type="text"
              v-bind="{ ...$attrs, class: null }"
              :placeholder="placeholder"
              @input="onInput"
              @focus="onFocus"
              @keydown.down.prevent="onArrowDown"
              @keydown.up.prevent="onArrowUp"
              @keydown.enter.tab.prevent="selectCurrentSelection"
              autocomplete="off"
          />
          <icon v-if="editItem" @click="editItem=false" name="close" class="w-4 h-4 ml-2 cursor-pointer" />
      </div>
    <div v-if="error" class="form-error">{{ error }}</div>
    <div v-if="isListVisible && items.length" class="i__filter__list">
      <ul>
        <li
          v-for="(item, index) in items"
          :key="index"
          :class="{ 'i__filter__active': index === activeIndex }"
          @mousedown.prevent="selectItem(item)"
        >{{ item.name }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import Icon from '@/Shared/Icon'

export default {
    components:{
        Icon
    },
  inheritAttrs: false,
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    onInput: {
      type: Function,
    },
    items: {
      type: Array
    },
    id: {
      type: String,
      default() {
        return `select-input-filter-${uuid()}`
      },
    },
      editable: [Number, Boolean],
    error: String,
    label: String,
    value: String,
    modelValue: [String, Number, Boolean],
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selectedValue: '',
      selected: this.modelValue,
      isListVisible: false,
        editItem: false,
        itemValue: this.value,
        activeIndex: -1
    }
  },
  watch: {
    selected(selected) {
      this.$emit('update:modelValue', selected)
        this.editItem = false
    },
  },
  created() {

  },
  mounted() {
    document.addEventListener('click', this.close)
  },
  methods: {
    close (e) {
      if (!this.$el.contains(e.target)) {
        this.isListVisible = false
      }
    },
    onFocus(){
      this.isListVisible = true
      this.activeIndex = -1
    },
    onArrowDown(){
      if (!this.isListVisible) { this.isListVisible = true; return }
      this.activeIndex = Math.min(this.activeIndex + 1, this.items.length - 1)
    },
    onArrowUp(){
      this.activeIndex = Math.max(this.activeIndex - 1, 0)
    },
    selectCurrentSelection(){
      if (this.activeIndex >= 0 && this.items[this.activeIndex]) {
        this.selectItem(this.items[this.activeIndex])
        return
      }
      const typed = (this.$refs.input?.value || '').trim().toLowerCase()
      if (!typed) return
      const match = this.items.find(i => i.name.toLowerCase() === typed)
      if (match) this.selectItem(match)
    },
    selectItem(item){
      this.$refs.input.value = item.name
      this.selected = item.id
      this.selectedValue = item.name
      this.isListVisible = false
        this.editItem = false
        this.itemValue = item.name
        this.activeIndex = -1
    },
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
  },
}
</script>
